(function () {
  var AVAILABILITY_PARAM = 'filter.v.availability';

  function getFacetFiltersDrawer(element) {
    return element ? element.closest('facet-filters.product-facet__filters--button-layout') : null;
  }

  function hasActiveProductFilters(params) {
    for (var key of params.keys()) {
      if (key.indexOf('filter.') === 0 && key !== AVAILABILITY_PARAM) {
        return true;
      }
    }
    return false;
  }

  function withAvailabilityParam(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      if (hasActiveProductFilters(parsed.searchParams)) {
        parsed.searchParams.set(AVAILABILITY_PARAM, '1');
      } else {
        parsed.searchParams.delete(AVAILABILITY_PARAM);
      }
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      return url;
    }
  }

  function buildFacetUrl(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (key && value !== '') {
        params.append(key, value);
      }
    }

    params.delete('page');
    return withAvailabilityParam(`${window.location.pathname}?${params.toString()}`);
  }

  function dispatchFacetCriteriaChanged(facetFilters, url) {
    facetFilters.dispatchEvent(
      new CustomEvent('facet:criteria-changed', {
        bubbles: true,
        detail: { url: url },
      })
    );
  }

  function closeFacetDrawer(facetFilters) {
    facetFilters.open = false;
  }

  // Ensure option/price filters always intersect with in-stock availability
  // before product-facet reloads the section (covers form + clear links).
  document.addEventListener(
    'facet:criteria-changed',
    function (event) {
      if (!event.detail || !event.detail.url) {
        return;
      }
      event.detail.url = withAvailabilityParam(event.detail.url);
    },
    true
  );

  document.addEventListener('change', function (event) {
    const target = event.target;

    if (!(target instanceof HTMLInputElement) || target.name !== 'sort_by') {
      return;
    }

    const facetFilters = getFacetFiltersDrawer(target);
    if (!facetFilters) {
      return;
    }

    const form = facetFilters.querySelector('#facet-filters-form');
    if (!form) {
      return;
    }

    dispatchFacetCriteriaChanged(facetFilters, buildFacetUrl(form));
  });

  document.addEventListener('click', function (event) {
    const applyButton = event.target.closest('[data-action="apply-filters"]');
    if (!applyButton) {
      return;
    }

    const facetFilters = getFacetFiltersDrawer(applyButton);
    if (!facetFilters) {
      return;
    }

    const form = facetFilters.querySelector('#facet-filters-form');
    if (!form) {
      return;
    }

    event.preventDefault();
    dispatchFacetCriteriaChanged(facetFilters, buildFacetUrl(form));
    closeFacetDrawer(facetFilters);
  });
})();
